import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { uploadImage } from "@/lib/api";

export const VideoUploader = ({ value, onChange, label }) => {
  const [loading, setLoading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("video/")) {
      toast.error("Bitte eine Videodatei wählen.");
      return;
    }
    if (file.size > 50 * 1024 * 1024) {
      toast.error("Video zu groß (max. 50 MB). Bitte komprimieren.");
      return;
    }
    setLoading(true);
    try {
      const res = await uploadImage(file);
      onChange(res.absoluteUrl);
      toast.success("Video hochgeladen.");
    } catch {
      toast.error("Upload fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2" data-testid={`video-uploader-${label}`}>
      {value && (
        <video src={value} className="w-full h-44 object-cover border border-gold/30 bg-ink" muted loop autoPlay playsInline />
      )}
      <div className="flex items-center gap-3">
        <label className="cursor-pointer inline-flex items-center gap-2 bg-wine text-cream px-4 py-2 text-xs uppercase tracking-[0.15em] hover:bg-wine-dark transition-colors">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          Video hochladen
          <input type="file" accept="video/mp4,video/webm,video/quicktime" className="hidden" onChange={onFile} disabled={loading} />
        </label>
      </div>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="oder Video-URL einfügen"
        className="w-full bg-transparent border-b border-wine/20 px-0 py-2 text-sm focus:border-wine focus:outline-none"
      />
      <p className="text-xs text-ink-muted">Empfohlen: MP4, max. 50 MB. Für schnelles Laden möglichst kurz & komprimiert.</p>
    </div>
  );
};
